export * from './list'

export enum CompanySubscriptionStatus {
    ACTIVE = 'Active',
    EXPIRED = 'Expired',
    CANCELED = 'Canceled',
    SUSPENDED = 'Suspended',
    PAYMENT_DUE = 'PaymentDue',
    PAUSE = 'Pause',
    TRIAL = 'Trial'
}

export const CompanySubscriptionStatusColors = {
    Active: '#22B254',
    Expired: '#F14D4D',
    Canceled: '#F14D4D',
    Suspended: '#FFC22D',
    PaymentDue: '#FFC22D',
    Pause: 'red'
}

export enum SubscriptionPaymentMethods {
    MANUAL = 'Manual',
    STRIPE_DIRECT = 'StripeDirect',
    STRIPE_SUBSCRIPTION = 'StripeSubscription',
    STRIPE_FUTURE = 'StripeFuture'
}
